module.exports = __webpack_public_path__ + "img/1523882751.31fba311.jpg";